"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CroupierAutoDealRule = void 0;
const game_rule_1 = require("./game-rule");
const auto_croupier_reveal_command_1 = require("../commands/auto-commands/auto-croupier-reveal-command");
const auto_croupier_deal_command_1 = require("../commands/auto-commands/auto-croupier-deal-command");
class CroupierAutoDealRule extends game_rule_1.AbstractGameRule {
    applyRule(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            // Finalise the current player before moving to the croupier
            context.playerManager.setCurrentPlayerComplete(instant);
            // Reveal the croupier hidden card
            yield this.revealCroupierCard(commandHash, existingDeal, instant, context);
            if (context.playerManager.hasWinningHands) {
                while (context.playerManager.croupier.canDeal) {
                    yield this.dealCroupierCard(commandHash, existingDeal, instant, context);
                }
            }
            return false;
        });
    }
    revealCroupierCard(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const autoCroupierRevealCommand = new auto_croupier_reveal_command_1.AutoCroupierRevealCommand();
            yield autoCroupierRevealCommand.executeCommand(commandHash, existingDeal, instant, context);
        });
    }
    dealCroupierCard(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const autoCroupierDealCommand = new auto_croupier_deal_command_1.AutoCroupierDealCommand();
            yield autoCroupierDealCommand.executeCommand(commandHash, existingDeal, instant, context);
        });
    }
}
exports.CroupierAutoDealRule = CroupierAutoDealRule;
